<template>
  <AppLink
    to="/"
    class="logo"
  >
    <img
      src="/bouman-potter.svg"
      alt="Bouman & Potter"
      class="logo__image"
      height="35"
      width="191"
      decoding="auto"
      loading="eager"
      fetchpriority="high"
    >
  </AppLink>
</template>

<style>
@import url("~layers/app/components/App/Logo.css");
</style>
